import React from 'react';
import { CalendarDaysIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

const RANGES = ['1Y', '3Y', '5Y', 'All'];

const formatDate = (value, isZh) => {
    const date = new Date(`${value}T00:00:00`);
    return new Intl.DateTimeFormat(isZh ? 'zh-CN' : 'en-US', {
        year: 'numeric',
        month: isZh ? 'numeric' : 'short',
        day: 'numeric',
    }).format(date);
};

const AIDevelopmentHeader = ({ asOf, range, onRangeChange, isZh = false }) => (
    <header className="ai-dev-hero">
        <div className="ai-dev-hero__eyebrow">AI DEVELOPMENT MONITOR · V1</div>
        <div className="ai-dev-hero__row">
            <div className="ai-dev-hero__copy">
                <h1>{isZh ? 'AI 发展监测' : 'AI Development Monitor'}</h1>
                <p>
                    {isZh
                        ? '用可追溯的能力、成本、使用、商业化、算力和经济扩散数据，观察 AI 产业的长期变化。'
                        : 'Long-run, traceable evidence across capability, cost, use, monetization, compute and economic diffusion.'}
                </p>
            </div>
            <div className="ai-dev-range" aria-label={isZh ? '全局时间范围' : 'Global time range'}>
                {RANGES.map((item) => (
                    <button
                        key={item}
                        type="button"
                        className={range === item ? 'is-active' : ''}
                        aria-pressed={range === item}
                        onClick={() => onRangeChange(item)}
                    >
                        {item}
                    </button>
                ))}
            </div>
        </div>
        <div className="ai-dev-hero__meta">
            <span><CalendarDaysIcon aria-hidden="true" />{isZh ? `数据截至 ${formatDate(asOf, true)}` : `Data through ${formatDate(asOf, false)}`}</span>
            <span><ShieldCheckIcon aria-hidden="true" />{isZh ? '数据源可追溯 · 不设综合总分' : 'Traceable sources · No composite score'}</span>
        </div>
    </header>
);

export default AIDevelopmentHeader;
